export default __webpack_public_path__ + "static/media/plus.6e544a27.svg";